import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card } from '../ui/card';

export const StatsCard = ({ 
  title, 
  value, 
  subtitle,
  trend, 
  icon: Icon,
  className = ''
}) => {
  const isPositive = trend?.isPositive;
  const trendValue = trend?.value;
  
  return (
    <Card 
      className={`p-6 border-white/5 bg-card/90 backdrop-blur-sm relative overflow-hidden group transition-all duration-300 hover:border-primary/20 ${className}`}
      data-testid="stats-card"
    >
      {/* Background gradient on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-4">
          <span className="text-muted-foreground text-sm font-manrope font-medium tracking-wide uppercase">
            {title}
          </span>
          {Icon && (
            <Icon className="w-5 h-5 text-muted-foreground/50 group-hover:text-primary/70 transition-colors duration-300" />
          )}
        </div>
        
        <div className="flex items-end justify-between">
          <div>
            <div className="text-3xl font-manrope font-bold tracking-tight text-foreground">
              {value}
            </div>
            {subtitle && (
              <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
            )}
          </div>
          
          {trendValue !== undefined && (
            <div className={`flex items-center gap-1 text-sm font-medium ${
              isPositive ? 'text-emerald-400' : 'text-rose-400'
            }`}>
              {isPositive ? (
                <TrendingUp className="w-4 h-4" />
              ) : (
                <TrendingDown className="w-4 h-4" />
              )}
              <span>{trendValue}%</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};
